(function($){
$(document).ready(function(e) {	
  
  if (sessionStorage.getItem('dontLoad') == null){
    $('.preloader').show();
                    // preloading con jqueryLoader2
                    $("body").queryLoader2({		
                        backgroundColor: "transparent",
                        percentage: false,
                        barHeight: 0
                    });
                    sessionStorage.setItem('dontLoad', 'true');
                } else {
                  $('.preloader').hide();
            };
  
  /*
    // preloading con jqueryLoader2
    $("body").queryLoader2({		
        backgroundColor: "transparent",
        percentage: false,
        barHeight: 0
    });*/
});
  
  /*$(document).ready(function(){
    // use localStorage.removeItem('show'); to unset an item
    var show = localStorage.getItem('show');
    if(show === 'true'){
        $('.preloader').hide();
    } else {
      $('.preloader').show();
        // preloading con jqueryLoader2
      $("body").queryLoader2({		
          backgroundColor: "transparent",
          percentage: false,
          barHeight: 0
      });
      localStorage.setItem('show', 'true');
    }
});*/
   })(jQuery);


